import {escape_reg_exp} from '../../_mixins/escape-reg-exp'

document.addEventListener('DOMContentLoaded', () => {
    const el_field_search = document.getElementById('js_page-field-filter')

    new AutoComplete({
        delay: 300,
        onSelect(event, term, item) {
            el_field_search.removeEventListener('keyup', keyup_field_search)
            location.assign(item.dataset.url);
        },
        renderItem(item, search) {
            let re = new RegExp('(' + escape_reg_exp(search).split(' ').join('|') + ')', 'gi')

            return `<div class="autocomplete-suggestion" data-val="${item.label.replace(/"/g, '&quot;')}" data-url="${item.url}">${item.label.replace(re, '<b>$1</b>')}</div>`
        },
        selector: el_field_search,
        source(query, res) {
            return fetch_custom(g_params.url_prefix + '/ajax_title_page_search', {
                params: {
                    count: 7,
                    term: query
                }
            })
                .then(data => res(data))
                .catch(handling_error)
        }
    })

    el_field_search.addEventListener('keyup', keyup_field_search)

    function keyup_field_search(event) {
        if (event.code !== 'Enter') return;

        location.assign(g_params.url_prefix + '/articles/flower-knowledge?title=' + event.target.value)
    }
})